/*!
* @novel/transformable v0.2.14
* (c) 2021 ludan.kibbon
*/
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DRAG_SWIPE_TIMEOUT = 1e2;
var DRAG_SWIPE_BOUNCE_MIN_RATE = 0.1;
var DRAG_SWIPE_BOUNCE_MAX_DIS = 0.33;
var FRAME_SPAN = 17;
var DRAG_MODE = {
  ALWAYS: 'always',
  HYBRID: 'hybrid',
  NONE: 'none'
};
var SWIPE_MODE = {
  ANIM: 'animation',
  TRANS: 'transition'
};
var TRANSFORM_MODE = {
  TRANS_FIRST: 'translate-first',
  SCALE_FIRST: 'scale-first'
};

function getDistance(v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}

function convert(arr) {
  if (arr instanceof Number) {
    return [arr];
  } else if (arr instanceof Array) {
    return [].concat(arr);
  } else {
    return [].concat(arr.valueOf());
  }
}

var Vector = /*#__PURE__*/function () {
  function Vector(arr) {
    var _this = this;

    _defineProperty(this, "operatorAdd", function (x) {
      x = convert(x);
      var val = x.length >= _this.x.length ? [x, _this.x] : [_this.x, x];
      return new Vector(val[0].map(function (v, i) {
        return v + (val[1][i] !== void 0 ? val[1][i] : val[1][0]);
      }));
    });

    _defineProperty(this, "operatorSub", function (x) {
      x = convert(x);
      var val = x.length > _this.x.length ? [x, _this.x] : [_this.x, x];
      return new Vector(val[0].map(function (v, i) {
        return v - (val[1][i] !== void 0 ? val[1][i] : val[1][0]);
      }));
    });

    _defineProperty(this, "operatorMul", function (x) {
      x = convert(x);
      var val = x.length > _this.x.length ? [x, _this.x] : [_this.x, x];
      return new Vector(val[0].map(function (v, i) {
        return v * (val[1][i] !== void 0 ? val[1][i] : val[1][0]);
      }));
    });

    _defineProperty(this, "operatorDiv", function (x) {
      x = convert(x);
      var val = x.length > _this.x.length ? [x, _this.x] : [_this.x, x];
      return new Vector(val[0].map(function (v, i) {
        return v / (val[1][i] !== void 0 ? val[1][i] : val[1][0]);
      }));
    });

    this.x = convert(arr) || [];
  }

  var _proto = Vector.prototype;

  _proto.get = function get(pos) {
    return this.x[pos];
  };

  _proto.v = function v() {
    return [].concat(this.x);
  };

  _proto.size = function size() {
    return this.x.length;
  };

  _proto.valueOf = function valueOf() {
    return this.x.valueOf();
  };

  _proto.toString = function toString() {
    return this.x.toString();
  };

  _proto.mul = function mul(x) {
    x = this.convert(x);

    if (x.length !== this.x.length) {
      throw new Error("Can not process vector inner-product, input vector dim " + x.length + " don't match resource vector dim " + this.x.length);
    }

    var sum = 0;
    this.x.forEach(function (v, i) {
      return sum += v + x[i];
    });
    return sum;
  };

  return Vector;
}();

function convert$1(x, _init) {
  if (typeof x === 'number') {
    return {
      R: x,
      I: 0
    };
  } else if (x.isComplex) {
    return x;
  } else {
    return {
      R: _init,
      I: 0
    };
  }
}

var Complex = /*#__PURE__*/function () {
  function Complex(_R, _I) {
    var _this = this;

    if (_I === void 0) {
      _I = 0;
    }

    _defineProperty(this, "operatorAdd", function (x) {
      x = convert$1(x, 0);
      var R = _this.R + x.R;
      var I = _this.I + x.I;
      return new Complex(R, I);
    });

    _defineProperty(this, "operatorSub", function (x) {
      x = convert$1(x, 0);
      var R = _this.R - x.R;
      var I = _this.I - x.I;
      return new Complex(R, I);
    });

    _defineProperty(this, "operatorMul", function (x) {
      x = convert$1(x, 1);
      var R = _this.R * x.R - _this.I * x.I;
      var I = _this.I * x.R + _this.R * x.I;
      return new Complex(R, I);
    });

    _defineProperty(this, "operatorDiv", function (x) {
      x = convert$1(x, 1);
      var D = Math.pow(x.R, 2) + Math.pow(x.I, 2);
      var R = (_this.R * x.R + _this.I * x.I) / D;
      var I = (_this.I * x.R - _this.R * x.I) / D;
      return new Complex(R, I);
    });

    _defineProperty(this, "operatorPow", function (x) {
      var Z = _this.z();

      if (Z === 0) {
        return new Complex(0);
      }

      var theta = Math.acos(_this.R / Z) * x;
      Z = Math.pow(Z, x);
      var R = Z * Math.cos(theta);
      var I = Z * Math.sin(theta);
      return new Complex(R, I);
    });

    if (typeof _R === 'number') {
      this.R = Number(_R);
      this.I = Number(_I);
    } else if (_R.isComplex) {
      this.R = _R.r();
      this.I = _R.i();
    }

    this.isComplex = true;
  }

  var _proto = Complex.prototype;

  _proto.valueOf = function valueOf() {
    return this.R.valueOf();
  };

  _proto.toString = function toString() {
    return this.R.toFixed(3) + "+" + this.I.toFixed(3) + "i";
  };

  _proto.isNaN = function (_isNaN) {
    function isNaN() {
      return _isNaN.apply(this, arguments);
    }

    isNaN.toString = function () {
      return _isNaN.toString();
    };

    return isNaN;
  }(function () {
    return isNaN(this.R) || isNaN(this.I);
  });

  _proto.isReal = function isReal() {
    return this.I === 0 && !this.isNaN();
  };

  _proto.inRangeR = function inRangeR(a, b) {
    return this.R <= b && this.R >= a;
  };

  _proto.inRangeI = function inRangeI(a, b) {
    return this.I <= b && this.I >= a;
  };

  _proto.setR = function setR(r) {
    this.R = Number(r);
  };

  _proto.setI = function setI(i) {
    this.I = Number(i);
  };

  _proto.r = function r() {
    return this.R;
  };

  _proto.i = function i() {
    return this.I;
  };

  _proto.z = function z() {
    return Math.sqrt(Math.pow(this.R, 2) + Math.pow(this.I, 2));
  };

  _proto.theta = function theta() {
    var Z = this.z();
    return Math.acos(this.R / Z);
  };

  return Complex;
}();

var _Op = function () {
  'bpo disable';

  return {
    add: function add(a, b) {
      if (a.operatorAdd) return a.operatorAdd(b);else return a + b;
    },
    sub: function sub(a, b) {
      if (a.operatorSub) return a.operatorSub(b);else return a - b;
    },
    mul: function mul(a, b) {
      if (a.operatorMul) return a.operatorMul(b);else return a * b;
    },
    div: function div(a, b) {
      if (a.operatorDiv) return a.operatorDiv(b);else return a / b;
    },
    pow: function pow(a, b) {
      if (a.operatorPow) return a.operatorPow(b);else return Math.pow(a, b);
    },
    binaryAnd: function binaryAnd(a, b) {
      if (a.operatorBinaryAnd) return a.operatorBinaryAnd(b);else return a & b;
    },
    binaryOr: function binaryOr(a, b) {
      if (a.operatorBinaryOr) return a.operatorBinaryOr(b);else return a | b;
    },
    binaryXor: function binaryXor(a, b) {
      if (a.operatorBinaryXor) return a.operatorBinaryXor(b);else return a ^ b;
    },
    binaryLShift: function binaryLShift(a, b) {
      if (a.operatorBinaryLShift) return a.operatorBinaryLShift(b);else return a << b;
    },
    binaryRShift: function binaryRShift(a, b) {
      if (a.operatorBinaryRShift) return a.operatorBinaryRShift(b);else return a >> b;
    },
    less: function less(a, b) {
      if (a.operatorLess) return a.operatorLess(b);else if (b.operatorGreater) return b.operatorGreater(a);else if (a.operatorGreaterEqual) return !a.operatorGreaterEqual(b);else return a < b;
    },
    greater: function greater(a, b) {
      if (a.operatorGreater) return a.operatorGreater(b);else if (b.operatorLess) return b.operatorLess(a);else if (a.operatorLessEqual) return !a.operatorLessEqual(b);else return a > b;
    },
    lessEqual: function lessEqual(a, b) {
      if (a.operatorLessEqual) return a.operatorLessEqual(b);else if (b.operatorGreaterEqual) return b.operatorGreaterEqual(a);else if (a.operatorGreater) return !a.operatorGreater(b);else return a <= b;
    },
    greaterEqual: function greaterEqual(a, b) {
      if (a.operatorGreaterEqual) return a.operatorGreaterEqual(b);else if (b.operatorLessEqual) return b.operatorLessEqual(a);else if (a.operatorLess) return !a.operatorLess(b);else return a >= b;
    },
    equal: function equal(a, b) {
      if (a.operatorEqual) return a.operatorEqual(b);else if (a.operatorNotEqual) return !a.operatorNotEqual(b);else if (b.operatorEqual) return b.operatorEqual(a);else if (b.operatorNotEqual) return !b.operatorNotEqual(a);else return a == b;
    },
    notEqual: function notEqual(a, b) {
      if (a.operatorNotEqual) return a.operatorNotEqual(b);else if (a.operatorEqual) return !a.operatorEqual(b);else if (b.operatorNotEqual) return b.operatorNotEqual(a);else if (b.operatorEqual) return !b.operatorEqual(a);else return a != b;
    }
  };
}();

function Sqrt(k) {
  if (k >= 0) {
    return Math.sqrt(k);
  } else {
    return new Complex(0, Math.sqrt(-k));
  }
}

var POW_3_1_2 = Math.sqrt(3);
var POW_2_1_3 = Math.pow(2, 1 / 3);
var I = Sqrt(-1);

var _I = new Complex(0).operatorSub(I);

var epsilon = 1e-12;

function getParam(T, x1, x2) {
  var a = -3 * x1 + 3 * x2 - 1;
  var b = -(2 * x1 - x2) / a;
  var c = -9 * Math.pow(x1, 2) + 9 * x2 * x1 + 9 * x1 - 9 * Math.pow(x2, 2);
  var d = 3 * a;
  var e = POW_2_1_3 * d;
  var subDelta = 54 * Math.pow(x1, 3) - 243 * T * Math.pow(x1, 2) - 81 * x2 * Math.pow(x1, 2) + 162 * Math.pow(x1, 2) - 81 * Math.pow(x2, 2) * x1 - 162 * T * x1 + 486 * T * x2 * x1 - 81 * x2 * x1 + 54 * Math.pow(x2, 3) - 243 * T * Math.pow(x2, 2) - 27 * T + 162 * T * x2;
  var delta = 4 * Math.pow(c, 3) + Math.pow(subDelta, 2);
  return [delta, subDelta, b, c, d, e];
}

function solveCubicBezier(T, x1, x2, firstAnswer) {
  'bpo enable';

  if (firstAnswer === void 0) {
    firstAnswer = true;
  }

  if (x1 === x2 && x1 === 0) {
    return Math.pow(T, _Op.div(1, 3));
  }

  var _getParam = getParam(T, x1, x2),
      delta = _getParam[0],
      subDelta = _getParam[1],
      b = _getParam[2],
      c = _getParam[3],
      d = _getParam[4],
      e = _getParam[5];

  var a = _Op.pow(new Complex(_Op.add(Sqrt(delta), subDelta)), _Op.div(1, 3));

  var t1 = _Op.add(_Op.sub(_Op.div(a, e), _Op.div(new Complex(_Op.mul(POW_2_1_3, c)), _Op.mul(a, d))), b);

  var answers = [];

  if (_Op.lessEqual(delta, epsilon)) {
    var t2 = _Op.add(_Op.add(_Op.div(_Op.mul(_Op.sub(_Op.mul(I, POW_3_1_2), 1), a), _Op.mul(2, e)), _Op.div(_Op.mul(_Op.add(_Op.mul(I, POW_3_1_2), 1), c), _Op.mul(_Op.mul(a, e), POW_2_1_3))), b);

    var t3 = _Op.add(_Op.add(_Op.div(_Op.mul(_Op.sub(_Op.mul(_I, POW_3_1_2), 1), a), _Op.mul(2, e)), _Op.div(_Op.mul(_Op.add(_Op.mul(_I, POW_3_1_2), 1), c), _Op.mul(_Op.mul(a, e), POW_2_1_3))), b);

    [t1, t2, t3].forEach(function (k) {
      k.inRangeR(0, 1) && answers.push(k.r());
    });
    answers.sort();
  } else {
    answers.push(t1.r());
  }

  return firstAnswer ? answers[0] : answers;
}

var _Op$1 = function () {
  'bpo disable';

  return {
    add: function add(a, b) {
      if (a.operatorAdd) return a.operatorAdd(b);else return a + b;
    },
    sub: function sub(a, b) {
      if (a.operatorSub) return a.operatorSub(b);else return a - b;
    },
    mul: function mul(a, b) {
      if (a.operatorMul) return a.operatorMul(b);else return a * b;
    },
    div: function div(a, b) {
      if (a.operatorDiv) return a.operatorDiv(b);else return a / b;
    },
    pow: function pow(a, b) {
      if (a.operatorPow) return a.operatorPow(b);else return Math.pow(a, b);
    },
    binaryAnd: function binaryAnd(a, b) {
      if (a.operatorBinaryAnd) return a.operatorBinaryAnd(b);else return a & b;
    },
    binaryOr: function binaryOr(a, b) {
      if (a.operatorBinaryOr) return a.operatorBinaryOr(b);else return a | b;
    },
    binaryXor: function binaryXor(a, b) {
      if (a.operatorBinaryXor) return a.operatorBinaryXor(b);else return a ^ b;
    },
    binaryLShift: function binaryLShift(a, b) {
      if (a.operatorBinaryLShift) return a.operatorBinaryLShift(b);else return a << b;
    },
    binaryRShift: function binaryRShift(a, b) {
      if (a.operatorBinaryRShift) return a.operatorBinaryRShift(b);else return a >> b;
    },
    less: function less(a, b) {
      if (a.operatorLess) return a.operatorLess(b);else if (b.operatorGreater) return b.operatorGreater(a);else if (a.operatorGreaterEqual) return !a.operatorGreaterEqual(b);else return a < b;
    },
    greater: function greater(a, b) {
      if (a.operatorGreater) return a.operatorGreater(b);else if (b.operatorLess) return b.operatorLess(a);else if (a.operatorLessEqual) return !a.operatorLessEqual(b);else return a > b;
    },
    lessEqual: function lessEqual(a, b) {
      if (a.operatorLessEqual) return a.operatorLessEqual(b);else if (b.operatorGreaterEqual) return b.operatorGreaterEqual(a);else if (a.operatorGreater) return !a.operatorGreater(b);else return a <= b;
    },
    greaterEqual: function greaterEqual(a, b) {
      if (a.operatorGreaterEqual) return a.operatorGreaterEqual(b);else if (b.operatorLessEqual) return b.operatorLessEqual(a);else if (a.operatorLess) return !a.operatorLess(b);else return a >= b;
    },
    equal: function equal(a, b) {
      if (a.operatorEqual) return a.operatorEqual(b);else if (a.operatorNotEqual) return !a.operatorNotEqual(b);else if (b.operatorEqual) return b.operatorEqual(a);else if (b.operatorNotEqual) return !b.operatorNotEqual(a);else return a == b;
    },
    notEqual: function notEqual(a, b) {
      if (a.operatorNotEqual) return a.operatorNotEqual(b);else if (a.operatorEqual) return !a.operatorEqual(b);else if (b.operatorNotEqual) return b.operatorNotEqual(a);else if (b.operatorEqual) return !b.operatorEqual(a);else return a != b;
    }
  };
}();
function splitCubicBezier(cubic, p, axis) {
  'bpo enable';

  if (axis === void 0) {
    axis = 'x';
  }

  var x1 = cubic[0],
      y1 = cubic[1],
      x2 = cubic[2],
      y2 = cubic[3];
  var t = axis === 'x' ? solveCubicBezier(p, x1, x2) : axis === 'y' ? solveCubicBezier(p, y1, y2) : p;

  var f = function f(x, y) {
    return _Op$1.add(_Op$1.mul(_Op$1.sub(y, x), t), x);
  };

  var A = new Vector([0, 0]);
  var B = new Vector([x1, y1]);
  var C = new Vector([x2, y2]);
  var D = new Vector([1, 1]);
  var E = f(A, B);
  var F = f(B, C);
  var G = f(C, D);
  var H = f(E, F);
  var J = f(F, G);
  var K = f(H, J);

  var _map = [E, H].map(function (v) {
    return _Op$1.div(v, _Op$1.add(K, 1e-9));
  }),
      B_1 = _map[0],
      C_1 = _map[1];

  var _map2 = [J, G].map(function (v) {
    return _Op$1.div(_Op$1.sub(v, K), _Op$1.add(_Op$1.sub(D, K), 1e-9));
  }),
      B_2 = _map2[0],
      C_2 = _map2[1];

  return [[].concat(B_1.v(), C_1.v()), [].concat(B_2.v(), C_2.v())];
}

function getCubicBezierVbyT(v1, v2, t) {
  return 3 * v1 * t * Math.pow(1 - t, 2) + 3 * v2 * (1 - t) * Math.pow(t, 2) + Math.pow(t, 3);
}

function getCubicBezierPoint(cubic, p, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var x1 = cubic[0],
      y1 = cubic[1],
      x2 = cubic[2],
      y2 = cubic[3];
  var t = p === 0 ? 0 : p === 1 ? 1 : axis === 'x' ? solveCubicBezier(p, x1, x2) : axis === 'y' ? solveCubicBezier(p, y1, y2) : p;
  return [axis === 'x' ? p : getCubicBezierVbyT(x1, x2, t), axis === 'y' ? p : getCubicBezierVbyT(y1, y2, t)];
}

function _raf(cb) {
  return window.requestAnimationFrame ? window.requestAnimationFrame(cb) : setTimeout(cb, FRAME_SPAN);
}

function _caf(cb) {
  return window.requestAnimationFrame ? window.cancelAnimationFrame(cb) : clearTimeout(cb, FRAME_SPAN);
}

var TransformAble = /*#__PURE__*/function () {
  function TransformAble(_options) {
    var _this = this;

    if (_options === void 0) {
      _options = {};
    }

    _defineProperty(this, "setBounce", function (bounce) {
      !isNaN(bounce) && (_this.bouncing = Number(bounce));
    });

    _defineProperty(this, "setDamp", function (damp) {
      if (damp === void 0) {
        damp = 0;
      }

      !isNaN(damp) && (_this.damp = Number(damp));
    });

    _defineProperty(this, "setTransform", function (transform, options) {
      if (transform === void 0) {
        transform = {};
      }

      if (options === void 0) {
        options = {};
      }

      if (_this.fixedX && transform.translateX) {
        delete transform.translateX;
      }

      if (_this.fixedY && transform.translateY) {
        delete transform.translateY;
      }

      if (!options.merge) {
        _this.transform = _extends({}, transform);
      } else {
        ['translateX', 'translateY', 'scale'].forEach(function (k) {
          transform[k] !== void 0 && (_this.transform[k] = parseFloat(transform[k]));
        });
        var _transform = transform,
            transformOrigin = _transform.transformOrigin;

        if (transformOrigin instanceof Array && transformOrigin.length === 2) {
          _this.transform.transformOrigin = transformOrigin.map(function (k) {
            return parseFloat(k);
          });
        }
      }

      if (!options.silent) {
        _this.update();
      }

      return _this;
    });

    _defineProperty(this, "on", function (event, f) {
      if (f && typeof f === 'function') {
        var evt = "on" + event[0].toUpperCase() + event.slice(1);

        if (_this[evt]) {
          if (evt === 'onTransform') {
            _this[evt] = function () {
              return f(_extends({}, _this.transform), {
                complete: !_this.busy(),
                dirty: _this.dirty()
              });
            };
          } else {
            _this[evt] = f;
          }
        } else {
          console.warn('[Transform]Unsupport event:', event);
        }
      }

      return _this;
    });

    _defineProperty(this, "restore", function (silent) {
      if (!silent) {
        var transform = _this.transform;

        _raf(function () {
          _this.onRestore(transform);
        });
      }

      if (_this.dragMode === DRAG_MODE.ALWAYS) {
        _this.zoomTo(1, {
          fitEdge: true
        });
      } else {
        _this.setTransform({}, {
          merge: false,
          silent: silent
        });
      }
    });

    _defineProperty(this, "getTransform", function (type) {
      switch (type) {
        case 'css':
          return _this.toCSS();

        case 'style':
          return _this.toStyle();

        default:
          return _extends({}, _this.transform);
      }
    });

    _defineProperty(this, "dirty", function () {
      var _this$transform = _this.transform,
          _this$transform$trans = _this$transform.translateX,
          translateX = _this$transform$trans === void 0 ? 0 : _this$transform$trans,
          _this$transform$trans2 = _this$transform.translateY,
          translateY = _this$transform$trans2 === void 0 ? 0 : _this$transform$trans2,
          _this$transform$scale = _this$transform.scale,
          scale = _this$transform$scale === void 0 ? 1 : _this$transform$scale;
      return translateX !== 0 || translateY !== 0 || scale !== 1;
    });

    _defineProperty(this, "busy", function () {
      return !_this.disableContentTouch || _this.cancelSwipe || _this.animating;
    });

    _defineProperty(this, "isTapStop", function () {
      return _this.isTapStopped;
    });

    _defineProperty(this, "apply", function () {
      if (_this.dom) {
        var css = _this.toCSS();

        _this.dom.style.transform = css.transform || '';
        _this.dom.style.webkitTransform = css.transform || '';
        _this.dom.style.transformOrigin = css.transformOrigin || 'center center';
        _this.dom.style.webkitTransformOrigin = css.transformOrigin || 'center center';
      }

      _this.onTransform();

      _this.timer = 0;
    });

    _defineProperty(this, "update", function () {
      _caf(_this.timer);

      _this.timer = _raf(_this.apply);
      _this.lastTransform = _extends({}, _this.transform);
    });

    _defineProperty(this, "cancel", function () {
      _caf(_this.timer);

      _this.transform = _extends({}, _this.lastTransform);
    });

    _defineProperty(this, "toTop", function () {
      var _this$transform$scale2 = _this.transform.scale,
          scale = _this$transform$scale2 === void 0 ? 1 : _this$transform$scale2;

      var _this$_remainToEdge = _this._remainToEdge(1, 1),
          remainY = _this$_remainToEdge[1];

      return Math.round(Math.abs(remainY / scale));
    });

    _defineProperty(this, "toBottom", function () {
      var _this$transform$scale3 = _this.transform.scale,
          scale = _this$transform$scale3 === void 0 ? 1 : _this$transform$scale3;

      var _this$_remainToEdge2 = _this._remainToEdge(1, -1),
          remainY = _this$_remainToEdge2[1];

      return Math.round(Math.abs(remainY / scale));
    });

    _defineProperty(this, "toLeft", function () {
      var _this$transform$scale4 = _this.transform.scale,
          scale = _this$transform$scale4 === void 0 ? 1 : _this$transform$scale4;

      var _this$_remainToEdge3 = _this._remainToEdge(1, 1),
          remainX = _this$_remainToEdge3[0];

      return Math.round(Math.abs(remainX / scale));
    });

    _defineProperty(this, "toRight", function () {
      var _this$transform$scale5 = _this.transform.scale,
          scale = _this$transform$scale5 === void 0 ? 1 : _this$transform$scale5;

      var _this$_remainToEdge4 = _this._remainToEdge(-1, 1),
          remainX = _this$_remainToEdge4[0];

      return Math.round(Math.abs(remainX / scale));
    });

    _defineProperty(this, "getOriginXY", function (touchAxis) {
      var clientX = touchAxis[0],
          clientY = touchAxis[1];

      var _this$_getTransformed = _this._getTransformedBounding(),
          left = _this$_getTransformed.left,
          top = _this$_getTransformed.top;

      var _this$transform$scale6 = _this.transform.scale,
          scale = _this$transform$scale6 === void 0 ? 1 : _this$transform$scale6;
      return [(clientX - left) / scale, (clientY - top) / scale];
    });

    _defineProperty(this, "setScreenCenter", function (clientX, clientY, forceUpdate) {
      var _this$getOriginXY = _this.getOriginXY([clientX, clientY]),
          originX = _this$getOriginXY[0],
          originY = _this$getOriginXY[1];

      return _this.setCenter(originX, originY, forceUpdate);
    });

    _defineProperty(this, "setCenter", function (x, y, forceUpdate) {
      var transform = _this.transform,
          fixedX = _this.fixedX,
          fixedY = _this.fixedY,
          boundingRect = _this.boundingRect,
          viewport = _this.viewport;
      var _transform$translateX = transform.translateX,
          translateX = _transform$translateX === void 0 ? 0 : _transform$translateX,
          _transform$translateY = transform.translateY,
          translateY = _transform$translateY === void 0 ? 0 : _transform$translateY,
          _transform$scale = transform.scale,
          scale = _transform$scale === void 0 ? 1 : _transform$scale;
      var transformOrigin = transform.transformOrigin;

      var _ref = boundingRect || viewport,
          top = _ref.top,
          bottom = _ref.bottom,
          left = _ref.left,
          right = _ref.right;

      if (!transformOrigin) {
        transformOrigin = [(right - left) / 2, (bottom - top) / 2];
      }

      if (!fixedX) {
        var disX = x - transformOrigin[0];
        x = transformOrigin[0] + disX;
        transform.translateX = translateX + disX * (scale - 1) / scale;
        transformOrigin[0] = x;
      }

      if (!fixedY) {
        var disY = y - transformOrigin[1];
        y = transformOrigin[1] + disY;
        transform.translateY = translateY + disY * (scale - 1) / scale;
        transformOrigin[1] = y;
      }

      transform.transformOrigin = transformOrigin;
      forceUpdate && _this.update();
    });

    _defineProperty(this, "zoomToScreenCenter", function (rate, center, options) {
      if (options === void 0) {
        options = {};
      }

      var x = center[0],
          y = center[1];

      _this.setScreenCenter(x, y, true);

      _raf(function () {
        return _raf(function () {
          _this.zoomTo(rate, _extends({
            fitEdge: true
          }, options));
        });
      });
    });

    _defineProperty(this, "zoomToCenter", function (rate, center, options) {
      if (options === void 0) {
        options = {};
      }

      var x = center[0],
          y = center[1];

      _this.setCenter(x, y, true);

      _raf(function () {
        return _raf(function () {
          _this.zoomTo(rate, _extends({
            fitEdge: true
          }, options));
        });
      });
    });

    _defineProperty(this, "zoomTo", function (rate, options) {
      if (options === void 0) {
        options = {};
      }

      var _options2 = options,
          _options2$transition = _options2.transition,
          transition = _options2$transition === void 0 ? 'all' : _options2$transition,
          _options2$easingFunc = _options2.easingFunc,
          easingFunc = _options2$easingFunc === void 0 ? 'ease-out' : _options2$easingFunc,
          _options2$duration = _options2.duration,
          duration = _options2$duration === void 0 ? 0 : _options2$duration,
          _options2$silent = _options2.silent,
          silent = _options2$silent === void 0 ? true : _options2$silent,
          _options2$fitEdge = _options2.fitEdge,
          fitEdge = _options2$fitEdge === void 0 ? false : _options2$fitEdge,
          callback = _options2.callback;
      var _this$maxScale = _this.maxScale,
          maxScale = _this$maxScale === void 0 ? 1 : _this$maxScale,
          _this$minScale = _this.minScale,
          minScale = _this$minScale === void 0 ? 1 : _this$minScale,
          transform = _this.transform;
      var _transform$scale2 = transform.scale,
          scale = _transform$scale2 === void 0 ? 1 : _transform$scale2,
          _transform$translateX2 = transform.translateX,
          translateX = _transform$translateX2 === void 0 ? 0 : _transform$translateX2,
          _transform$translateY2 = transform.translateY,
          translateY = _transform$translateY2 === void 0 ? 0 : _transform$translateY2;
      var newScale = Math.max(Math.min(rate, maxScale), minScale);
      var r = newScale / scale;
      _this.transform.scale = newScale;
      _this.transform.translateX = translateX / r;
      _this.transform.translateY = translateY / r;
      fitEdge && _this.fit(false);

      if (_this.dom && duration) {
        _this.dom.style.transition = transition + " " + duration + "ms " + easingFunc;
        _this.animating = true;
        setTimeout(function () {
          _this.dom.style.transition = '';
          _this.animating = false;
          !silent && _this.onZoomEnd(null, newScale);
          typeof callback === 'function' && callback(newScale);
        }, duration);
      } else {
        typeof callback === 'function' && callback(newScale);
      }

      _this.update();
    });

    _defineProperty(this, "zoom", function (rate, options) {
      if (rate === void 0) {
        rate = 1;
      }

      if (options === void 0) {
        options = {};
      }

      var _this$transform$scale7 = _this.transform.scale,
          scale = _this$transform$scale7 === void 0 ? 1 : _this$transform$scale7;

      _this.zoomTo(scale * rate, options);
    });

    _defineProperty(this, "drag", function (disX, disY, useBounce, ignoreEdgeX, ignoreEdgeY) {
      var transform = _this.transform,
          interActBound = _this.interActBound,
          fixedX = _this.fixedX,
          fixedY = _this.fixedY,
          bounceRateX = _this.bounceRateX,
          bounceRateY = _this.bounceRateY;
      var _transform$translateX3 = transform.translateX,
          translateX = _transform$translateX3 === void 0 ? 0 : _transform$translateX3,
          _transform$translateY3 = transform.translateY,
          translateY = _transform$translateY3 === void 0 ? 0 : _transform$translateY3,
          _transform$scale3 = transform.scale,
          scale = _transform$scale3 === void 0 ? 1 : _transform$scale3;
      fixedX && (disX = 0);
      fixedY && (disY = 0);

      var _this$_remainToEdge5 = _this._remainToEdge(disX, disY, interActBound),
          edgeX = _this$_remainToEdge5[0],
          edgeY = _this$_remainToEdge5[1];

      var overEdgeX = (edgeX + disX) * disX > 0;
      var overEdgeY = (edgeY + disY) * disY > 0;
      var offsetX = 0;
      var offsetY = 0;
      var slideX = Math.abs(disX) > Math.abs(disY);
      var toEdge = slideX && overEdgeX || !slideX && overEdgeY;

      if (disX) {
        if (ignoreEdgeX) {
          offsetX = disX;
        } else {
          offsetX = _this._getDragV(disX, edgeX, overEdgeX, useBounce ? bounceRateX : 0);
        }

        _this.transform.translateX = translateX + offsetX / scale;
      }

      if (disY) {
        if (ignoreEdgeY) {
          offsetY = disY;
        } else {
          offsetY = _this._getDragV(disY, edgeY, overEdgeY, useBounce ? bounceRateY : 0);
        }

        _this.transform.translateY = translateY + offsetY / scale;
      }

      var remain = [!fixedX ? -edgeX : 0, !fixedY ? -edgeY : 0];

      _this.update();

      if (_this.interActBound) {
        var left = interActBound.left,
            right = interActBound.right,
            top = interActBound.top,
            bottom = interActBound.bottom;
        _this.interActBound = {
          left: left + offsetX,
          right: right + offsetX,
          top: top + offsetY,
          bottom: bottom + offsetY
        };
      }

      return {
        toEdge: toEdge,
        remain: remain
      };
    });

    _defineProperty(this, "fit", function (useBounce, ignoreX, ignoreY) {
      if (useBounce === void 0) {
        useBounce = true;
      }

      var changed = false;
      var _this$transform2 = _this.transform,
          _this$transform2$tran = _this$transform2.translateX,
          translateX = _this$transform2$tran === void 0 ? 0 : _this$transform2$tran,
          _this$transform2$tran2 = _this$transform2.translateY,
          translateY = _this$transform2$tran2 === void 0 ? 0 : _this$transform2$tran2,
          _this$transform2$scal = _this$transform2.scale,
          scale = _this$transform2$scal === void 0 ? 1 : _this$transform2$scal;

      var _this$_outOfEdge = _this._outOfEdge(),
          outX = _this$_outOfEdge.outX,
          outY = _this$_outOfEdge.outY,
          outLeft = _this$_outOfEdge.outLeft,
          outRight = _this$_outOfEdge.outRight,
          outTop = _this$_outOfEdge.outTop,
          outBottom = _this$_outOfEdge.outBottom;

      if (!ignoreX && outX) {
        outRight && (_this.transform.translateX = translateX + outRight / scale);
        outLeft && (_this.transform.translateX = translateX + outLeft / scale);
        changed = true;
      }

      if (!ignoreY && outY) {
        outBottom && (_this.transform.translateY = translateY + outBottom / scale);
        outTop && (_this.transform.translateY = translateY + outTop / scale);
        changed = true;
      }

      changed && useBounce && _this.bounce();

      _this.update();

      return changed;
    });

    _defineProperty(this, "fitX", function (useBounce) {
      if (useBounce === void 0) {
        useBounce = true;
      }

      return _this.fit(useBounce, false, true);
    });

    _defineProperty(this, "fitY", function (useBounce) {
      if (useBounce === void 0) {
        useBounce = true;
      }

      return _this.fit(useBounce, true, false);
    });

    _defineProperty(this, "swipe", function (v) {
      var damp = _this.damp;

      if (damp) {
        var l = getDistance(v);

        if (isNaN(l)) {
          return;
        }

        if (_this.cancelSwipe) {
          _this.cancelSwipe();
        }

        var timer = 0;
        var steps = Math.ceil(l / _this.damp);
        var _this$transform3 = _this.transform,
            _this$transform3$tran = _this$transform3.translateX,
            translateX = _this$transform3$tran === void 0 ? 0 : _this$transform3$tran,
            _this$transform3$tran2 = _this$transform3.translateY,
            translateY = _this$transform3$tran2 === void 0 ? 0 : _this$transform3$tran2,
            _this$transform3$scal = _this$transform3.scale,
            scale = _this$transform3$scal === void 0 ? 1 : _this$transform3$scal;
        var scrollCubic = [].concat(_this.cubic.scroll),
            bounceCubic = [].concat(_this.cubic.bounce);

        if (_this.dom) {
          var swipeSpan = 50 * FRAME_SPAN;
          var cubicBezier = [null, scrollCubic];
          var timeout = 0;
          var bounceXTimer = 0;
          var bounceYTimer = 0;
          var baseFrame = [[0, [translateX * scale, translateY * scale]]];

          var finishSwipe = function finishSwipe() {
            timeout = 0;

            _this.cancelSwipe();
          };

          var swipeX = v[0] * steps / 2,
              swipeY = v[1] * steps / 2;
          var bounceRateX = _this.bounceRateX,
              bounceRateY = _this.bounceRateY;

          var _this$_outOfEdge2 = _this._outOfEdge(),
              outX = _this$_outOfEdge2.outX,
              outY = _this$_outOfEdge2.outY;

          var _this$drag = _this.drag(swipeX, swipeY, false, bounceRateX, bounceRateY),
              remain = _this$drag.remain;

          var _this$_outOfEdge3 = _this._outOfEdge(),
              overEdgeX = _this$_outOfEdge3.outX,
              overEdgeY = _this$_outOfEdge3.outY;

          if (overEdgeX || overEdgeY) {
            cubicBezier[1] = bounceCubic;
          }

          var bounceMaxX = window.innerWidth * DRAG_SWIPE_BOUNCE_MAX_DIS,
              bounceMaxY = window.innerHeight * DRAG_SWIPE_BOUNCE_MAX_DIS;

          if (_this.swipeMode === SWIPE_MODE.ANIM) {
            _this.cancel();

            var yFrame = _this._setSwipeBounceByAnimation(swipeY, remain[1], overEdgeY, outY, bounceRateY, swipeSpan, cubicBezier[1], bounceMaxY);

            var xFrame = _this._setSwipeBounceByAnimation(swipeX, remain[0], overEdgeX, outX, bounceRateX, swipeSpan, cubicBezier[1], bounceMaxX);

            var bouncedX = xFrame.length > 1;
            var bouncedY = yFrame.length > 1;
            [xFrame, yFrame].forEach(function (frame, idx) {
              return frame.forEach(function (keyFrame) {
                keyFrame[1] += baseFrame[0][1][idx];

                for (var i = 0; i < baseFrame.length; i += 1) {
                  if (keyFrame[0] === baseFrame[i][0]) {
                    baseFrame[i][1][idx] = keyFrame[1];
                    return;
                  } else if (keyFrame[0] < baseFrame[i][0]) {
                    var _pos = [null, null];
                    _pos[idx] = keyFrame[1];
                    baseFrame.splice(i, 0, [keyFrame[0], _pos]);
                    return;
                  }
                }

                var pos = [null, null];
                pos[idx] = keyFrame[1];
                baseFrame.push([keyFrame[0], pos]);
              });
            });
            var duration = baseFrame[baseFrame.length - 1][0];
            var pointCache = {};
            baseFrame.forEach(function (frame, i) {
              var t = frame[0],
                  pos = frame[1];
              pos.map(function (p, idx) {
                if (p === null) {
                  var lastP = baseFrame[i - 1][1][idx];
                  var lastT = baseFrame[i - 1][0];
                  var nextP = lastP;
                  var nextT = lastT;

                  for (var j = i + 1; j < baseFrame.length; j += 1) {
                    if (baseFrame[j][1][idx] !== null) {
                      nextP = baseFrame[j][1][idx];
                      nextT = baseFrame[j][0];
                      break;
                    }
                  }

                  if (lastT !== nextT) {
                    var y = [];
                    [lastT, t, nextT].forEach(function (_t, j) {
                      if (pointCache[_t]) {
                        y[j] = pointCache[_t];
                      } else {
                        y[j] = getCubicBezierPoint(cubicBezier[1], _t / duration, 'x')[1];
                      }
                    });
                    frame[1][idx] = lastP + (nextP - lastP) * (y[1] - y[0]) / (y[2] - y[0]);
                  } else {
                    frame[1][idx] = lastP;
                  }
                }
              });
            });
            baseFrame.forEach(function (frame) {
              frame[1] = "transform: " + _this.toCSS({
                translateX: frame[1][0] / scale,
                translateY: frame[1][1] / scale,
                scale: scale
              }).transform;
            });

            _this._appendAnimation(baseFrame, "cubic-bezier(" + cubicBezier[1].join(','), duration);

            timeout = setTimeout(finishSwipe, duration + FRAME_SPAN);

            _this.cancelSwipe = function () {
              _this._stopAnimation();

              _this._syncDom();

              _this.dom.style.animation = '';

              if (timeout) {
                clearTimeout(timeout);
                (bouncedX || bouncedY) && _this.fit(false);
              }

              _this.cancelSwipe = null;

              _this.onSwipeEnd(_this.transform);
            };
          } else {
            _this.dom.style.transition = "transform " + swipeSpan + "ms cubic-bezier(" + cubicBezier[1].join(',') + ")";
            timer = _raf(function () {
              timeout = setTimeout(finishSwipe, swipeSpan);

              var syncContext = function syncContext(f) {
                var resp = f(swipeSpan, cubicBezier) || {};
                swipeSpan = resp.swipeSpan || swipeSpan;
                cubicBezier = resp.cubicBezier || cubicBezier;
                clearTimeout(timeout);
                timeout = setTimeout(finishSwipe, swipeSpan);
              };

              if (overEdgeX) {
                if (outX && swipeX * remain[0] > 0) {
                  _this.fitX(false);
                } else {
                  cubicBezier[1] = [].concat(bounceCubic);
                  bounceXTimer = _this._setSwipeBounce(swipeX, remain[0], bounceRateX, syncContext, 'x', bounceMaxX);
                }
              }

              if (overEdgeY) {
                if (outY && swipeY * remain[1] > 0) {
                  _this.fitY(false);
                } else {
                  cubicBezier[1] = [].concat(bounceCubic);
                  bounceYTimer = _this._setSwipeBounce(swipeY, remain[1], bounceRateY, syncContext, 'y', bounceMaxY);
                }
              }
            });

            _this.cancelSwipe = function () {
              timer && _caf(timer);

              if (timeout) {
                bounceXTimer && clearTimeout(bounceXTimer);
                bounceYTimer && clearTimeout(bounceYTimer);
                clearTimeout(timeout);

                _this._syncDom();

                (bounceXTimer || bounceYTimer) && _this.fit(false);
              }

              _this.dom.style.transition = '';
              _this.cancelSwipe = null;

              _this.onSwipeEnd(_this.transform);
            };
          }
        } else {
          var dx = v[0] / steps;
          var dy = v[1] / steps;

          var animate = function animate() {
            var disX = (steps - 0.5) * dx,
                disY = (steps - 0.5) * dy;

            _this.drag(disX, disY);

            steps -= 1;

            if (steps > 0) {
              timer = _raf(animate);

              _this.cancelSwipe = function () {
                timer && _caf(timer);
                _this.cancelSwipe = null;

                _this.onSwipeEnd(_this.transform);
              };
            } else {
              timer = 0;

              _this.cancelSwipe();
            }
          };

          timer = _raf(animate);
        }
      }
    });

    _defineProperty(this, "bounce", function () {
      var bouncing = _this.bouncing;

      if (bouncing && _this.dom) {
        _this.dom.style.transition = "all " + bouncing + "ms cubic-bezier(.14, 1, .34, 1)";
        _this.animating = true;
        setTimeout(function () {
          _this.animating = false;
          _this.dom.style.transition = '';
        }, bouncing);
      }
    });

    _defineProperty(this, "touchStart", function (e) {
      _this.disableContentTouch = true;

      if (_this.active && !_this.animating) {
        _this.scaling = false;
        _this.dragging = false;

        if (_this.cancelSwipe) {
          _this.cancelSwipe();

          _this.isTapStopped = true;
        } else if (!_this.dirty()) {
          if (_this.useDomBoundary) {
            _this.setBoundary(_this.dom.getBoundingClientRect());
          }

          _this.onSchedule();
        }

        if (e.touches.length > 1) {
          var _this$transform$scale8 = _this.transform.scale,
              scale = _this$transform$scale8 === void 0 ? 1 : _this$transform$scale8;
          _this.disableContentTouch = false;

          var _this$getOriginXY2 = _this.getOriginXY([(e.touches[1].clientX + e.touches[0].clientX) / 2, (e.touches[1].clientY + e.touches[0].clientY) / 2]),
              x = _this$getOriginXY2[0],
              y = _this$getOriginXY2[1];

          _this.pinchStartCenter = [x, y];

          _this.setCenter(x, y);

          _this.pinchStartLen = getDistance([e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY]);
          _this.scaling = true;

          _this.onZoomStart(e, scale, _this.pinchStartCenter);
        } else if (_this.dragMode === DRAG_MODE.ALWAYS || _this.dragMode === DRAG_MODE.HYBRID && _this.dirty()) {
          _this.disableContentTouch = false;
          _this.dragStartTime = +new Date();
          _this.lastDragStartTime = 0;

          var _x = e.touches && e.touches[0] ? e.touches[0].clientX : 0,
              _y = e.touches && e.touches[0] ? e.touches[0].clientY : 0;

          _this.dragStartV = [_x, _y];
          _this.lastDragStartV = [];
          _this.dragX = _x;
          _this.dragY = _y;
        }
      }
    });

    _defineProperty(this, "touchMove", function (e) {
      if (!_this.disableContentTouch) {
        var _e$changedTouches = e.changedTouches,
            changedTouches = _e$changedTouches === void 0 ? [] : _e$changedTouches;

        if (_this.scaling) {
          if (e.touches.length > 1) {
            var pinchLen = getDistance([e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY]);

            _this.zoom(pinchLen / _this.pinchStartLen);

            _this.pinchStartLen = pinchLen;
          }
        } else {
          var touchMoveX = changedTouches[0] ? changedTouches[0].clientX : 0;
          var touchMoveY = changedTouches[0] ? changedTouches[0].clientY : 0;
          var disX = touchMoveX - _this.dragX;
          var disY = touchMoveY - _this.dragY;

          var _this$drag2 = _this.drag(disX, disY, _this.dragging),
              toEdge = _this$drag2.toEdge;

          _this.dragX = touchMoveX;
          _this.dragY = touchMoveY;
          var dragStartTime = +new Date();

          if (dragStartTime > _this.dragStartTime + DRAG_SWIPE_TIMEOUT) {
            _this.lastDragStartV = _this.dragStartV;
            _this.lastDragStartTime = _this.dragStartTime;
            _this.dragStartTime = dragStartTime;
            _this.dragStartV = [touchMoveX, touchMoveY];
          }

          if (!_this.dragging) {
            _this.dragging = true;

            if (toEdge) {
              _this.disableContentTouch = true;
            } else {
              _this.onDragStart(e);

              _this.interActBound = _this._getTransformedBounding(true);
            }
          }
        }

        _this.preventScroll && e.preventDefault();
      }
    });

    _defineProperty(this, "touchEnd", function (e) {
      if (!_this.disableContentTouch) {
        if (e.touches.length === 0) {
          var _this$transform$scale9 = _this.transform.scale,
              scale = _this$transform$scale9 === void 0 ? 1 : _this$transform$scale9;

          if (_this.scaling) {
            _this.onZoomEnd(e, scale, _this.pinchStartCenter);

            if (scale < 1) {
              _this.restore();
            } else {
              _this.fit();
            }
          } else if (_this.dragging) {
            var dragCostTime = +new Date() - _this.dragStartTime;
            var dragStartV = _this.dragStartV;

            if (dragCostTime < 50 && _this.lastDragStartTime) {
              dragCostTime = +new Date() - _this.lastDragStartTime;
              dragStartV = _this.lastDragStartV;
            }

            var dragEndV = [e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : 0, e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : 0];
            var swipeV = [FRAME_SPAN * (dragEndV[0] - dragStartV[0]) / dragCostTime, FRAME_SPAN * (dragEndV[1] - dragStartV[1]) / dragCostTime];

            _this.onDragEnd(e);

            if (getDistance(swipeV) > _this.motionThreshold) {
              _this.swipe(swipeV);
            } else {
              _this.fit();
            }
          }

          _raf(function () {
            _this.disableContentTouch = true;
            _this.pinchStartLen = 0;
            _this.interActBound = null;
            _this.isTapStopped = false;
          });
        }
      }
    });

    _defineProperty(this, "_outOfEdge", function () {
      var _this$_getTransformed2 = _this._getTransformedBounding(),
          left = _this$_getTransformed2.left,
          right = _this$_getTransformed2.right,
          top = _this$_getTransformed2.top,
          bottom = _this$_getTransformed2.bottom;

      var edges = _this.edges;
      var toLeft = edges.left - left;
      var toRight = edges.right - right;
      var toTop = edges.top - top;
      var toBottom = edges.bottom - bottom;
      var outLeft = toLeft < 0 ? toLeft : 0;
      var outRight = toRight > 0 ? toRight : 0;
      var outTop = toTop < 0 ? toTop : 0;
      var outBottom = toBottom > 0 ? toBottom : 0;
      return {
        outX: !!(outLeft || outRight),
        outY: !!(outTop || outBottom),
        outLeft: outLeft,
        outRight: outRight,
        outTop: outTop,
        outBottom: outBottom
      };
    });

    _defineProperty(this, "_remainToEdge", function (disX, disY, boundingRect) {
      var remain = [0, 0];
      var edges = _this.edges;

      var _ref2 = boundingRect || _this._getTransformedBounding(),
          left = _ref2.left,
          right = _ref2.right,
          top = _ref2.top,
          bottom = _ref2.bottom;

      var srcEdgeX = disX > 0 ? edges.left : edges.right;
      var srcEdgeY = disY > 0 ? edges.top : edges.bottom;
      var edgeX = disX > 0 ? left : right;
      var edgeY = disY > 0 ? top : bottom;
      remain[0] = edgeX - srcEdgeX;
      remain[1] = edgeY - srcEdgeY;
      return remain;
    });

    _defineProperty(this, "_computeEdge", function () {
      var _this$viewport = _this.viewport,
          l = _this$viewport.left,
          r = _this$viewport.right,
          t = _this$viewport.top,
          b = _this$viewport.bottom;

      if (_this.boundingRect) {
        var _this$boundingRect = _this.boundingRect,
            left = _this$boundingRect.left,
            right = _this$boundingRect.right,
            top = _this$boundingRect.top,
            bottom = _this$boundingRect.bottom;
        _this.edges = {
          left: Math.max(left, l),
          top: Math.max(top, t),
          right: Math.min(right, r),
          bottom: Math.min(bottom, b)
        };
      } else {
        _this.edges = _extends({}, _this.viewport);
      }
    });

    this.dom = null;
    this.useDomBoundary = false;
    this.viewport = {
      left: 0,
      right: window.innerWidth,
      top: 0,
      bottom: window.innerHeight
    };
    this.boundingRect = null;
    this.maxScale = 2;
    this.minScale = 0.5;
    this.fixedX = false;
    this.fixedY = false;
    this.active = true;
    this.preventScroll = true;
    this.dragMode = DRAG_MODE.HYBRID;
    this.swipeMode = SWIPE_MODE.ANIM;
    this.transformMode = TRANSFORM_MODE.TRANS_FIRST;
    this.cubic = {
      scroll: [.33, 1, .66, 1],
      bounce: [.17, 1, .17, 1]
    };
    this.transform = {};

    this.onZoomStart = function () {};

    this.onZoomEnd = function () {};

    this.onDragStart = function () {};

    this.onDragEnd = function () {};

    this.onSwipeEnd = function () {};

    this.onTransform = function () {};

    this.onRestore = function () {};

    this.onSchedule = function () {};

    this.bouncing = 3e2;
    this.bounceRateX = 0;
    this.bounceRateY = 0;
    this.damp = 2;
    this.motionThreshold = 10;
    this.config(_options);
    this.disableContentTouch = true;
    this.scaling = false;
    this.pinchStartCenter = [];
    this.pinchStartLen = 0;
    this.dragging = false;
    this.dragX = 0;
    this.dragY = 0;
    this.dragStartTime = 0;
    this.dragStartV = [0, 0];
    this.edges = {};
    this.timer = 0;
    this.animating = false;
    this.cancelSwipe = null;
    this.isTapStopped = false;
    this.interActBound = null;

    this._computeEdge();

    this.lastTransform = {};
    this.animationStyleDom = null;
  }

  var _proto = TransformAble.prototype;

  _proto.enable = function enable() {
    this.active = true;
    return this;
  };

  _proto.disable = function disable() {
    this.active = false;
    return this;
  };

  _proto.config = function config(options) {
    if (options === void 0) {
      options = {};
    }

    var _options3 = options,
        viewport = _options3.viewport,
        dom = _options3.dom,
        useDomBoundary = _options3.useDomBoundary,
        maxScale = _options3.maxScale,
        minScale = _options3.minScale,
        fixedX = _options3.fixedX,
        fixedY = _options3.fixedY,
        bounceRateX = _options3.bounceRateX,
        bounceRateY = _options3.bounceRateY,
        active = _options3.active,
        preventScroll = _options3.preventScroll,
        transform = _options3.transform,
        damp = _options3.damp,
        dragMode = _options3.dragMode,
        swipeMode = _options3.swipeMode,
        cubic = _options3.cubic,
        transformMode = _options3.transformMode,
        motionThreshold = _options3.motionThreshold,
        bounce = _options3.bounce,
        onZoomStart = _options3.onZoomStart,
        onZoomEnd = _options3.onZoomEnd,
        onDragStart = _options3.onDragStart,
        onDragEnd = _options3.onDragEnd,
        onSwipeEnd = _options3.onSwipeEnd,
        onTransform = _options3.onTransform,
        onRestore = _options3.onRestore,
        onSchedule = _options3.onSchedule;
    viewport && this.setViewport(viewport);
    dom && this.setDom(dom, useDomBoundary);
    maxScale && this.setMaxScale(maxScale);
    minScale && this.setMinScale(minScale);
    dragMode && this.setDragMode(dragMode);
    swipeMode && this.setSwipeMode(swipeMode);
    transformMode && this.setTransformMode(transformMode);
    cubic && this.setCubic(cubic);
    motionThreshold !== void 0 && this.setMotionThreshold(motionThreshold);
    bounceRateX !== void 0 && this.setBounceRateX(bounceRateX);
    bounceRateY !== void 0 && this.setBounceRateY(bounceRateY);
    fixedX !== void 0 && this.setFixedX(fixedX);
    fixedY !== void 0 && this.setFixedY(fixedY);
    active !== void 0 && (this.active = Boolean(active));
    preventScroll !== void 0 && (this.preventScroll = Boolean(preventScroll));
    transform && this.setTransform(transform);
    damp !== void 0 && this.setDamp(damp);
    bounce !== void 0 && this.setBounce(bounce);
    this.on('transform', onTransform).on('restore', onRestore).on('schedule', onSchedule).on('zoomStart', onZoomStart).on('zoomEnd', onZoomEnd).on('dragStart', onDragStart).on('dragEnd', onDragEnd).on('swipeEnd', onSwipeEnd);
    return this;
  };

  _proto.setDom = function setDom(dom, useDomBoundary) {
    var _this2 = this;

    if (useDomBoundary === void 0) {
      useDomBoundary = true;
    }

    if (dom) {
      this.useDomBoundary = useDomBoundary;

      if (this.dom !== dom) {
        this.removeDom();
        this.dom = dom;
        dom.addEventListener('touchstart', this.touchStart);
        dom.addEventListener('touchmove', this.touchMove);
        dom.addEventListener('touchend', this.touchEnd);
        dom.addEventListener('touchcancel', this.touchEnd);
        dom.style.willChange = 'transform';
        dom.style.transition = '';
        dom.style.transform = '';
        dom.style.webkitTransform = '';
        dom.style.transformOrigin = '';
        dom.style.webkitTransformOrigin = '';
        this.transform = {};
        this.lastTransform = {};

        if (useDomBoundary) {
          _raf(function () {
            if (!_this2.boundingRect) {
              _this2.setBoundary(dom.getBoundingClientRect());
            }
          });
        }
      }
    }

    return this;
  };

  _proto.setBoundary = function setBoundary(bounding, transformed) {
    if (transformed === void 0) {
      transformed = false;
    }

    var _ref3 = !transformed ? bounding : this._getRawBounding(bounding),
        left = _ref3.left,
        right = _ref3.right,
        top = _ref3.top,
        bottom = _ref3.bottom;

    this.boundingRect = _extends({}, this.boundingRect || this.viewport, {
      left: left,
      right: right,
      top: top,
      bottom: bottom
    });

    this._computeEdge();

    return this;
  };

  _proto.removeDom = function removeDom() {
    if (this.dom) {
      this.dom.removeEventListener('touchstart', this.touchStart);
      this.dom.removeEventListener('touchmove', this.touchMove);
      this.dom.removeEventListener('touchend', this.touchEnd);
      this.dom.removeEventListener('touchcancel', this.touchEnd);
    }

    return this;
  };

  _proto.setMaxScale = function setMaxScale(maxScale) {
    if (!isNaN(maxScale)) {
      this.maxScale = Math.max(Number(maxScale), 1);
    }

    return this;
  };

  _proto.setMinScale = function setMinScale(minScale) {
    if (!isNaN(minScale)) {
      this.minScale = Math.min(Number(minScale), 1);
    }

    return this;
  };

  _proto.setMotionThreshold = function setMotionThreshold(motionThreshold) {
    if (!isNaN(motionThreshold)) {
      this.motionThreshold = motionThreshold;
    }

    return this;
  };

  _proto.setCubic = function setCubic(cubic) {
    if (cubic === void 0) {
      cubic = {};
    }

    for (var k in cubic) {
      if (cubic[k] instanceof Array && cubic[k].length === 4) {
        this.cubic[k] = cubic[k].map(function (k) {
          return isNaN(Number(k)) ? Number(k) : 0;
        });
      }
    }

    return this;
  };

  _proto.setDragMode = function setDragMode(mode) {
    this.dragMode = mode;
  };

  _proto.setSwipeMode = function setSwipeMode(mode) {
    this.swipeMode = mode;
  };

  _proto.setTransformMode = function setTransformMode(mode) {
    this.transformMode = mode;
  };

  _proto.setBounceRateX = function setBounceRateX(bounceRateX) {
    if (!isNaN(bounceRateX)) {
      this.bounceRateX = Math.min(Number(bounceRateX), 1);
    }

    return this;
  };

  _proto.setBounceRateY = function setBounceRateY(bounceRateY) {
    if (!isNaN(bounceRateY)) {
      this.bounceRateY = Math.min(Number(bounceRateY), 1);
    }

    return this;
  };

  _proto.setViewport = function setViewport(viewport) {
    var _this3 = this;

    if (viewport === void 0) {
      viewport = {};
    }

    var changed = false;
    ['left', 'right', 'top', 'bottom'].forEach(function (k) {
      var val = Number(viewport[k]);

      if (!isNaN(val)) {
        _this3.viewport[k] = val;
        changed = true;
      }
    });
    changed && this._computeEdge();
    return this;
  };

  _proto.setFixedX = function setFixedX(fixedX) {
    this.fixedX = !!fixedX;

    if (fixedX) {
      var transformOrigin = this.transform.transformOrigin;

      if (transformOrigin) {
        var _ref4 = this.boundingRect || this.viewport,
            left = _ref4.left,
            right = _ref4.right;

        transformOrigin[0] = (right - left) / 2;
      }

      this.setTransform({
        translateX: 0
      }, {
        merge: true
      });
    }

    return this;
  };

  _proto.setFixedY = function setFixedY(fixedY) {
    this.fixedY = !!fixedY;

    if (fixedY) {
      var transformOrigin = this.transform.transformOrigin;

      if (transformOrigin) {
        var _ref5 = this.boundingRect || this.viewport,
            top = _ref5.top,
            bottom = _ref5.bottom;

        transformOrigin[1] = (bottom - top) / 2;
      }

      this.setTransform({
        translateY: 0
      }, {
        merge: true
      });
    }

    return this;
  };

  _proto.toStyle = function toStyle() {
    var _this$toCSS = this.toCSS(),
        transform = _this$toCSS.transform,
        transformOrigin = _this$toCSS.transformOrigin;

    var styleStr = '';
    transform && (styleStr += "transform: " + transform);
    transformOrigin && (styleStr += "transform-origin: " + transformOrigin);
    return styleStr;
  };

  _proto.toCSS = function toCSS(t) {
    var transform = '';
    var transformOrigin = 'center';

    if (t || this.dirty()) {
      var trans = t || this.transform;

      if (this.transformMode === TRANSFORM_MODE.TRANS_FIRST) {
        var _this$transform$scale10 = this.transform.scale,
            scale = _this$transform$scale10 === void 0 ? 1 : _this$transform$scale10;
        ['translateX', 'translateY'].forEach(function (key) {
          trans[key] !== void 0 && (transform += key + "(" + trans[key] * scale + "px)");
        });
        transform += "scale(" + scale + ")";
      } else if (this.transformMode === TRANSFORM_MODE.SCALE_FIRST) {
        ['scale', 'translateX', 'translateY'].forEach(function (key, isTranslate) {
          var unit = isTranslate ? 'px' : '';
          trans[key] !== void 0 && (transform += key + "(" + trans[key] + unit + ")");
        });
      } else {
        var _trans$scale = trans.scale,
            _scale = _trans$scale === void 0 ? 1 : _trans$scale,
            _trans$translateX = trans.translateX,
            translateX = _trans$translateX === void 0 ? 0 : _trans$translateX,
            _trans$translateY = trans.translateY,
            translateY = _trans$translateY === void 0 ? 0 : _trans$translateY;

        transform = "matrix(" + _scale + ", 0, 0, " + _scale + ", " + translateX * _scale + ", " + translateY * _scale + ")";
      }
    }

    if (this.transform.transformOrigin) {
      transformOrigin = this.transform.transformOrigin.map(function (i) {
        return Math.round(i) + "px";
      }).join(' ');
    }

    return {
      transform: transform,
      transformOrigin: transformOrigin
    };
  };

  _proto._getTransformedBounding = function _getTransformedBounding() {
    var boundingRect = this.boundingRect,
        viewport = this.viewport,
        transform = this.transform;

    var _ref6 = boundingRect || viewport,
        left = _ref6.left,
        top = _ref6.top,
        right = _ref6.right,
        bottom = _ref6.bottom;

    var _transform$scale4 = transform.scale,
        scale = _transform$scale4 === void 0 ? 1 : _transform$scale4,
        _transform$transformO = transform.transformOrigin,
        transformOrigin = _transform$transformO === void 0 ? [(right - left) / 2, (bottom - top) / 2] : _transform$transformO,
        _transform$translateX4 = transform.translateX,
        translateX = _transform$translateX4 === void 0 ? 0 : _transform$translateX4,
        _transform$translateY4 = transform.translateY,
        translateY = _transform$translateY4 === void 0 ? 0 : _transform$translateY4;
    var x = transformOrigin[0],
        y = transformOrigin[1];
    var offsetX = (translateX - x) * scale + x;
    var offsetY = (translateY - y) * scale + y;
    return {
      left: left + offsetX,
      right: left + offsetX + (right - left) * scale,
      top: top + offsetY,
      bottom: top + offsetY + (bottom - top) * scale
    };
  };

  _proto._getRawBounding = function _getRawBounding(boundingRect) {
    var transform = this.transform;
    var left = boundingRect.left,
        top = boundingRect.top,
        right = boundingRect.right,
        bottom = boundingRect.bottom;
    var _transform$scale5 = transform.scale,
        scale = _transform$scale5 === void 0 ? 1 : _transform$scale5,
        _transform$transformO2 = transform.transformOrigin,
        transformOrigin = _transform$transformO2 === void 0 ? [(right - left) / 2, (bottom - top) / 2] : _transform$transformO2,
        _transform$translateX5 = transform.translateX,
        translateX = _transform$translateX5 === void 0 ? 0 : _transform$translateX5,
        _transform$translateY5 = transform.translateY,
        translateY = _transform$translateY5 === void 0 ? 0 : _transform$translateY5;
    var x = transformOrigin[0],
        y = transformOrigin[1];
    var offsetX = (translateX - x) * scale + x;
    var offsetY = (translateY - y) * scale + y;
    return {
      left: left - offsetX,
      right: left - offsetX + (right - left) / scale,
      top: top - offsetY,
      bottom: top - offsetY + (bottom - top) / scale
    };
  };

  _proto._getDragV = function _getDragV(dis, edge, overEdge, bounceRate) {
    var bounce = 0;
    var offset = 0;

    if (overEdge) {
      if (bounceRate) {
        var bounceEdge = edge * dis > 0;
        bounce = bounceEdge ? dis * bounceRate : (edge + dis) * bounceRate;
        offset = bounceEdge ? bounce : -edge + bounce;
      } else {
        offset = -edge;
      }
    } else {
      offset = dis;
    }

    return offset;
  };

  _proto._setSwipeBounceByAnimation = function _setSwipeBounceByAnimation(swipe, remain, over, out, bounceRate, duration, cubicBezier, max) {
    if (max === void 0) {
      max = Infinity;
    }

    var frames = [];
    var outSwipe = swipe * remain < 0;

    if (over) {
      if (out && !outSwipe) {
        frames.push([duration, remain]);
      } else {
        var bounceActDis = outSwipe ? swipe * bounceRate : (swipe - remain) * bounceRate;

        if (Math.abs(bounceActDis) > max) {
          bounceActDis *= Math.abs(max / bounceActDis);
        }

        var firstDis = bounceActDis + (outSwipe ? 0 : remain);
        var bounce = firstDis / swipe;
        var t = getCubicBezierPoint(cubicBezier, bounce, 'y')[0];
        var delay = Math.floor(duration * t);

        if (t > DRAG_SWIPE_BOUNCE_MIN_RATE) {
          frames.push([duration, remain]);
        } else {
          frames.push([delay, firstDis]);
          frames.push([duration, remain]);
        }
      }
    } else {
      swipe = Math.min(Math.abs(swipe), Math.abs(remain)) * Math.abs(swipe) / swipe;
      frames.push([duration, swipe]);
    }

    return frames;
  };

  _proto._setSwipeBounce = function _setSwipeBounce(swipe, remain, bounceRate, syncCb, direction, max) {
    var _this4 = this;

    if (direction === void 0) {
      direction = 'x';
    }

    if (max === void 0) {
      max = Infinity;
    }

    var overEdge = swipe * remain < 0;
    var bounceActDis = overEdge ? swipe * bounceRate : (swipe - remain) * bounceRate;

    if (Math.abs(bounceActDis) > max) {
      bounceActDis *= Math.abs(max / bounceActDis);
    }

    var bounce = (bounceActDis + (overEdge ? 0 : remain)) / swipe;
    var timer = 0;
    syncCb(function (swipeSpan, cubicBezier) {
      var point = getCubicBezierPoint(cubicBezier[1], bounce, 'y');
      var delay = Math.max(Math.floor(point[0] * swipeSpan / FRAME_SPAN), 2) * FRAME_SPAN;
      var nextSpan = swipeSpan - delay;
      timer = setTimeout(function () {
        syncCb(function (swipeSpan, cubicBezier) {
          var t = 1 - nextSpan / swipeSpan;
          var offsetSpan = 0;

          var update = function update() {
            if (direction === 'x') {
              _this4.fitX(false);
            } else if (direction === 'y') {
              _this4.fitY(false);
            }

            if (_this4.dom) {
              _this4.dom.style.transition = "transform " + (nextSpan - offsetSpan) + "ms cubic-bezier(" + cubicBezier[1].map(function (k) {
                return k.toFixed(3);
              }).join(',') + ")";
            }
          };

          if (t > 0) {
            cubicBezier = splitCubicBezier(cubicBezier[1], t, 'x');
            update();
          } else {
            t = FRAME_SPAN / swipeSpan;
            offsetSpan = FRAME_SPAN;
            cubicBezier = splitCubicBezier(cubicBezier[1], t, 'x');

            _raf(update);
          }

          return {
            cubicBezier: cubicBezier,
            swipeSpan: nextSpan
          };
        });
      }, delay);
    });
    return timer;
  };

  _proto._syncDom = function _syncDom() {
    if (this.dom) {
      var matrix = window.getComputedStyle(this.dom).getPropertyValue('transform');

      var _matrix$split$0$split = matrix.split(')')[0].split(', ').map(function (k) {
        return parseFloat(k);
      }),
          _matrix$split$0$split2 = _matrix$split$0$split[3],
          scale = _matrix$split$0$split2 === void 0 ? 1 : _matrix$split$0$split2,
          _matrix$split$0$split3 = _matrix$split$0$split[4],
          translateX = _matrix$split$0$split3 === void 0 ? 0 : _matrix$split$0$split3,
          _matrix$split$0$split4 = _matrix$split$0$split[5],
          translateY = _matrix$split$0$split4 === void 0 ? 0 : _matrix$split$0$split4;

      this.setTransform({
        scale: scale,
        translateX: Math.round(translateX) / scale,
        translateY: Math.round(translateY) / scale
      }, {
        merge: true
      });
    }
  };

  _proto._appendStyle = function _appendStyle(css) {
    if (!this.animationStyleDom) {
      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      head.appendChild(style);
      style.type = 'text/css';
      this.animationStyleDom = style;
    } else {
      var node = this.animationStyleDom.firstChild;
      node && this.animationStyleDom.removeChild(node);
    }

    if (this.animationStyleDom.styleSheet) {
      this.animationStyleDom.styleSheet.cssText = css;
    } else {
      this.animationStyleDom.appendChild(document.createTextNode(css));
    }
  };

  _proto._appendAnimation = function _appendAnimation(keyFrames, easingFunc, duration) {
    var _this5 = this;

    var hash = parseInt((0.5 + 0.5 * Math.random()) * 1e16).toString(16);
    var key = "__transformable_key_" + hash;
    var frame = [];

    for (var i = 0; i < keyFrames.length; i += 1) {
      var _keyFrames$i = keyFrames[i],
          current = _keyFrames$i[0],
          style = _keyFrames$i[1];
      var percent = Math.floor(1e2 * (current / duration));
      frame.push(percent + "% { " + style + " }");
    }

    var styleTxt = "@keyframes " + key + " {\n            " + frame.join('\n') + "\n        }";

    this._appendStyle(styleTxt);

    if (this.dom) {
      _raf(function () {
        _this5.dom.style.animation = key + " " + duration + "ms " + easingFunc;
        _this5.dom.style.animationFillMode = 'forwards';
      });
    }
  };

  _proto._stopAnimation = function _stopAnimation() {
    if (this.dom) {
      this.dom.style.animationPlayState = 'paused';
    }
  };

  return TransformAble;
}();

export default TransformAble;
//# sourceMappingURL=transformable.es.js.map
